import { createFileRoute, redirect, useLocation, useNavigate } from "@tanstack/react-router";
import { useState } from "react";

import { NoProjectsHero } from "../components/onboarding/NoProjectsHero";
import { WelcomeWizard } from "../components/onboarding/WelcomeWizard";
import { useHandleNewThread } from "../hooks/useHandleNewThread";
import { resolveWelcomeRouteRedirect } from "./-welcomeRoute.logic";

/**
 * Ported from upstream `apps/web/src/routes/welcome.tsx` (parity pin
 * `e3e7cc3f`): onboarding overlays the workspace, and visiting /welcome
 * reopens setup. The delta is the auth lane: upstream redirects to /pair,
 * forge redirects to /login.
 */
export const Route = createFileRoute("/welcome")({
  beforeLoad: ({ context }) => {
    const target = resolveWelcomeRouteRedirect(context.authGateState?.status === "authenticated");
    if (target) {
      throw redirect({ to: target, replace: true });
    }
  },
  component: WelcomeRouteView,
});

function WelcomeRouteView() {
  const navigate = useNavigate();
  // The root shell can remount this pending outlet after the location changes.
  // Never reopen setup while the destination route is still loading.
  const isWelcomeRoute = useLocation({ select: (location) => location.pathname === "/welcome" });
  const [dismissed, setDismissed] = useState(false);
  const { openNewThread } = useHandleNewThread();
  return (
    <>
      <NoProjectsHero />
      {isWelcomeRoute && !dismissed ? (
        <WelcomeWizard
          onDone={(projectRef) => {
            setDismissed(true);
            if (projectRef !== undefined) {
              void openNewThread(projectRef).catch(() => {
                void navigate({ to: "/new", replace: true });
              });
              return;
            }
            void navigate({ to: "/new", replace: true });
          }}
        />
      ) : null}
    </>
  );
}
